import type { Banner, BannerQueryParams } from '../models/BannerModel';

export default abstract class BannerRepository {
  abstract getBanners(params: BannerQueryParams): Promise<Banner[]>;
  abstract recordImpression(bannerId: string, lat?: number, lng?: number): Promise<void>;
  abstract recordClick(bannerId: string, lat?: number, lng?: number): Promise<void>;
}
